import { noop } from "lodash";
import {
  ComponentProps,
  FunctionComponent,
  useCallback,
  useContext,
} from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { useAppLoader } from "../../../components/loader/app-loader-hook";
import { GlobalOverlayContext } from "../../../components/overlay/context";
import { WalletsService } from "../../../store/wallets/service";

const CTA = styled(PrimaryButton)`
  margin-top: 2em;
`;

const Address = styled.p`
  font-size: 1.1em;
  font-weight: 700;
  word-break: break-all;
`;

export const RemoveWalletModal: FunctionComponent<{
  address: string;
  id: string;
}> = ({ id, address }) => {
  const loader = useAppLoader();
  const { setOverlay } = useContext(GlobalOverlayContext);

  const onRemove = useCallback(
    () =>
      loader(
        WalletsService.removeWallet(id)
          .then(() => setOverlay({ children: undefined }))
          .catch(noop)
      ),
    [id]
  );

  return (
    <>
      <p>Are you sure you want to remove:</p>
      <Address>{address} ?</Address>
      <CTA onClick={onRemove}>Confirm</CTA>
    </>
  );
};

export type RemoveWalletModalProps = ComponentProps<typeof RemoveWalletModal>;
